import { ADD, SET_LOADING, MINUS } from '../mutation-types';

export default {
  namespaced: true,
  state: {
    amount: 0,
    queue: [],
    isLoading: false,
  },
  mutations: {
    [ADD](state) {
      state.amount++;
      state.isLoading = true;
    },
    [SET_LOADING](state, isLoading) {
      state.isLoading = isLoading;
    },
    [MINUS](state) {
      state.amount--;
    },
  },
  actions: {
    add({ commit }) {
      commit(ADD);
    },
    setLoading({ commit }, isLoading) {
      commit(SET_LOADING, isLoading);
    },
    complete({ commit }) {
      commit(MINUS);
    },
  },
  getters: {
    loadingAmount(state) {
      return state.amount;
    },
    isLoading(state) {
      return state.isLoading;
    },
  },
};
